/* @ngInject */
function removeHtmlTag() {
  return (text) => (text ? String(text).replace(/<[^>]+>|&#160;|&#8217|&#65279;/gm, ' ') : '');
}

export default removeHtmlTag;




// WEBPACK FOOTER //
// ./client/components/remove-html-tag/remove-html-tag.filter.js